import React, { useState } from 'react';
import './History.css';
import { Heading, PageTitle } from '../../../components';
import { historyData, titles } from '../../../constants';
import { FaLeaf, FaHistory, FaLandmark, FaPlus } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

import Lightbox from "react-18-image-lightbox";
import "react-18-image-lightbox/style.css";

const History = () => {
    const { t } = useTranslation();

    // -- LOGIKA GALERII --
    const [index, setIndex] = useState(-1);
    
    // Zabezpieczenie: jeśli historyData.gallery nie istnieje, użyj pustej tablicy
    const galleryImages = historyData?.gallery || [];

    const currentImage = galleryImages[index];
    const nextIndex = (index + 1) % galleryImages.length;
    const nextImage = galleryImages[nextIndex] || currentImage;
    const prevIndex = (index + galleryImages.length - 1) % galleryImages.length;
    const prevImage = galleryImages[prevIndex] || currentImage;

    const openLightbox = (i) => setIndex(i);
    const closeLightbox = () => setIndex(-1);
    const handleMovePrev = () => setIndex(prevIndex);
    const handleMoveNext = () => setIndex(nextIndex);
    // --------------------

    const renderIcon = (type) => {
        if (type === 'landmark') return <FaLandmark />;
        if (type === 'leaf') return <FaLeaf />;
        return <FaHistory />;
    };

    // Dodatkowy guard na przypadek, gdy historyData jest undefined
    if (!historyData) return null;

    return (
        <>
            <PageTitle title={t(titles.history || '')} page={t(historyData.page || '')} />

            <section className='history-section'>
                <Heading title={t(historyData.heading || '')} subTitle={t(historyData.subHeading || '')} />

                <div className='history-intro'>
                    <p>{t(historyData.intro || '')}</p>
                </div>

                <div className='history-container'>

                    {/* Zabezpieczone mapowanie bloków */}
                    {(historyData.blocks || []).map((block) => (
                        <div key={block.id} className={`history-block ${block.reverse ? 'reverse' : ''}`}>
                            <div className='image'>
                                <img src={block.image} alt={t(block.title || '')} />
                            </div>
                            <div className='content'>
                                <div className='icon-wrapper'>
                                    {renderIcon(block.iconType)}
                                </div>
                                <h3>{t(block.title || '')}</h3>
                                
                                {/* Zabezpieczenie na pętli po paragrafach */}
                                {(block.paragraphs || []).map((p, index) => (
                                    <p key={index}>{t(p)}</p>
                                ))}
                            </div>
                        </div>
                    ))}

                    <div className='heritage-mission-wrapper'>

                        {/* Dziedzictwo */}
                        <div className='heritage-box'>
                            <h3>{t(historyData.heritage?.title || '')}</h3>
                            <p>{t(historyData.heritage?.intro || '')}</p>
                            <ul>
                                {/* Zabezpieczenie na pętli po liście dziedzictwa */}
                                {(historyData.heritage?.list || []).map((item, index) => (
                                    <li key={index}>
                                        <FaLeaf className='icon' /> {t(item)}
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Misja */}
                        <div className='mission-box'>
                            <h3>{t(historyData.mission?.title || '')}</h3>
                            <p>{t(historyData.mission?.text || '')}</p>
                            <h4>{t(historyData.mission?.slogan || '')}</h4>
                        </div>
                    </div>

                </div>

                {/* --- SEKCJA GALERII --- */}
                {galleryImages.length > 0 && (
                    <div className="museo-gallery-section" style={{ marginTop: '6rem' }}>
                        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
                        </div>

                        <div className='museo-gallery-grid'>
                            {galleryImages.map((item, i) => {
                                return (
                                    <div key={i} className={`museo-gallery-item`}>
                                        <img src={item} alt={`${t('Zdjecie')} ${i + 1}`} />
                                        <div className="museo-gallery-overlay">
                                            <button onClick={() => openLightbox(i)}>
                                                <FaPlus className='museo-gallery-icon' />
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {index !== -1 && (
                            <Lightbox
                                mainSrc={currentImage}
                                mainSrcThumbnail={currentImage}
                                nextSrc={nextImage}
                                nextSrcThumbnail={nextImage}
                                prevSrc={prevImage}
                                prevSrcThumbnail={prevImage}
                                onCloseRequest={closeLightbox}
                                onMovePrevRequest={handleMovePrev}
                                onMoveNextRequest={handleMoveNext}
                            />
                        )}
                    </div>
                )}
                {/* --- KONIEC SEKCJI GALERII --- */}

            </section>
        </>
    );
};

export default History;